module.exports = __webpack_public_path__ + "img/manage-benefits.65459ebd.svg";